import type { Dispatch } from "redux";
import BillingAction from "../../actions/BillingAction";

export const AI_CONTENT_TOKEN_QUOTA_ERROR = "AI_CONTENT_TOKEN_QUOTA_EXCEEDED";

export function isAiContentQuotaExceededError(error: unknown): boolean {
  const err = error as {
    response?: { status?: number; data?: { error?: string } };
    error?: string;
  };
  if (err?.response?.status === 429) {
    return true;
  }
  const code = err?.response?.data?.error ?? err?.error;
  return code === AI_CONTENT_TOKEN_QUOTA_ERROR;
}

export function getAiContentQuotaErrorMessage(error: unknown): string | undefined {
  const err = error as { response?: { data?: { message?: string } }; message?: string };
  return err?.response?.data?.message ?? err?.message;
}

/** Opens upgrade flow for AI token limits (Content Studio). Returns true when handled. */
export function handleAiContentQuotaError(dispatch: Dispatch<any>, error: unknown): boolean {
  if (!isAiContentQuotaExceededError(error)) {
    return false;
  }
  dispatch(
    BillingAction.showUpgradePlanDialog({
      aiContentTokensPerMonth: true,
    })
  );
  return true;
}

export function showAiContentQuotaUpgrade(dispatch: Dispatch<any>) {
  dispatch(
    BillingAction.showUpgradePlanDialog({
      aiContentTokensPerMonth: true,
    })
  );
}
